<script>
    import { fade } from "svelte/transition";

    import { apiMethods } from "../../../../../Services/index.svelte";

    import CodeSelectorManualAsaSurgerySelector from "./CodeSelectorManualASASurgerySelector.svelte";
    import {
        getAsaItemCodeLabel,
        updateSurgeryItems,
    } from "../../../helpers/asaHelper.svelte";
    import { showException } from "../../../../../Utils/utilFunctions.svelte";
    import { PageLoading } from "../../../../../Components/Common/index.svelte";

    export let itemProps = {},
        doctorId = 0,
        procedureName = "",
        defaultItems = [],
        selectedItems = [],
        updateItems = () => {},
        openNotification = () => {};

    $: isCardiacEncounter = itemProps.billingType == 3;

    $: if (defaultItems.length) _syncSuggestedItems();

    $: if (!isLoadingSuggestedItems && !hasSuggestedItemsFetched)
        loadSurgerySuggestedItems();

    let isAllSurgeryModalOpen = false,
        suggestedItems = [],
        specialItems = [];

    let isLoadingSuggestedItems = false,
        hasSuggestedItemsFetched = false;

    const suggestedItemsArr = [
        "Lens",
        "Upper GI endoscopy",
        "Lower GI endoscopy",
    ];

    const suggestedCardiacItemsArr = [
        "CD560",
        "CD565",
        "CD570",
        "CD580",
        "CD582",
        "CD584",
    ];

    const loadSurgerySuggestedItems = async () => {

        isLoadingSuggestedItems = true;

        await apiMethods.getMethod
            .getSurgerySuggestedItems(procedureName, doctorId)
            .then((res) => {
                if (res.length > 0) {
                    var itemCodes = res.filter((r) => r.itemCode).map((r) => r.itemCode);
                    suggestedItems = defaultItems.filter((item) =>
                        itemCodes.includes(item.itemCode),
                    );
                }
            })
            .catch((err) => {
                showException(err);
            });

        isLoadingSuggestedItems = false;

        hasSuggestedItemsFetched = true;
    };

    const handleSelectItem = (item) => {
        updateItems(
            updateSurgeryItems(
                item,
                selectedItems,
                itemProps,
                openNotification,
            ),
        );
    };

    // HELPER FUNCTIONS
    const _syncSuggestedItems = () => {
        suggestedItems = defaultItems.filter(({ itemCode, infoShortTitle }) =>
            isCardiacEncounter
                ? suggestedCardiacItemsArr.includes(itemCode)
                : suggestedItemsArr.includes(infoShortTitle),
        );
    };

    const _openAllSurgeryModal = () => (isAllSurgeryModalOpen = true);

    const _closeAllSurgeryModal = () => (isAllSurgeryModalOpen = false);
</script>

<div
    class="flex flex-col gap-y-2 border-2 rounded-md justify-center p-4"
    transition:fade={{ duration: isCardiacEncounter ? 100 : 0 }}
>
    {#if isLoadingSuggestedItems}
        <PageLoading />
    {:else}
        <div class="flex flex-1 items-center justify-between">
            <p class="font-bold text-lg">Surgery</p>

            <button
                class="btn btn-sm btn-secondary"
                on:click|preventDefault={_openAllSurgeryModal}
            >
                View All
            </button>
        </div>

        <p class="text-md text-secondary">Suggested</p>

        <div class="flex flex-col gap-y-2 px-2">
            {#each suggestedItems as item}
                <div class="flex flex-1 items-center justify-between">
                    <div class="flex flex-col">
                        <p class="text-xs">
                            {item.infoRegion}: {item.infoSubRegion}
                        </p>
                        <p class="text md font-bold">
                            {getAsaItemCodeLabel(item)}
                            {item.infoShortTitle} ({item.amaUnits})
                        </p>
                    </div>

                    <button
                        class={`w-8 h-8 rounded-full text-[16px] text-[#fff] ${
                            selectedItems.some((itm) => itm.id == item.id)
                                ? "hidden"
                                : "bg-secondary"
                        }`}
                        on:click|preventDefault={() => handleSelectItem(item)}
                    >
                        <i
                            class={`fa-solid ${
                                selectedItems.some((itm) => itm.id == item.id)
                                    ? "fa-minus"
                                    : "fa-plus"
                            }`}
                        />
                    </button>
                </div>
            {/each}
        </div>
    {/if}
</div>

<CodeSelectorManualAsaSurgerySelector
    isModalOpen={isAllSurgeryModalOpen}
    {defaultItems}
    {selectedItems}
    addItem={handleSelectItem}
    closeModal={_closeAllSurgeryModal}
/>
